jQuery(function ($) {
	$(".share-link").on("click", function() {

		const targetElement = $(this);
		toggleShareContainer(targetElement);
		$(".share-container .heateor_sss_sharing_container").find("a").on("click", function() {
			toggleShareContainer(targetElement);
		})
	})

	function toggleShareContainer(target) {
		$(target).toggleClass("active");
		$(".share-container").find(".heateor_sss_sharing_container").toggle();		
	}
});